//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import menuDetailBrand from '@/views/platformReport/components/menuDetailBrand.vue';
import menuDetailEntity from '@/views/platformReport/components/menuDetailEntity.vue';
import menuDetailMovie from '@/views/platformReport/components/menuDetailMovie.vue';
import menuDetailCommon from '@/views/platformReport/components/menuDetailCommon.vue';
var BRAND_VISIBLE_TYPES = ['cake_store_sxd',
// 蛋糕自由兑
'code',
// 电子卡密
'cake_store',
// 蛋糕到店
'online_foods',
// 在线点单
'vipCard',
// 权益直充
'cake' // 蛋糕到家
];
export default {
  components: {
    menuDetailBrand: menuDetailBrand,
    menuDetailEntity: menuDetailEntity,
    menuDetailMovie: menuDetailMovie,
    menuDetailCommon: menuDetailCommon
  },
  props: {
    /**
     * drawerVisible 抽屉显示状态
    */
    drawerVisible: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    /**
     * entry 入口类型
     * platformReport - 平台报表-订单消费统计
     * abnormalOrderMonitor - 平台报表-异常订单监控
     * orderListDetail - 订单列表-订单详情
    */
    entry: {
      type: String,
      default: function _default() {
        return 'platformReport';
      }
    },
    /**
     * originParams 原始参数
    */
    originParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    drawerTitle: function drawerTitle() {
      var _this$originParams;
      return "".concat(((_this$originParams = this.originParams) === null || _this$originParams === void 0 ? void 0 : _this$originParams.category_name) || '', " \u660E\u7EC6");
    }
  },
  data: function data() {
    return {
      BRAND_VISIBLE_TYPES: BRAND_VISIBLE_TYPES
    };
  },
  watch: {
    // 监听抽屉显示状态，显示时加载数据
    drawerVisible: function drawerVisible(isShow) {
      if (isShow) {}
    }
  },
  methods: {
    handleCancel: function handleCancel() {
      this.$emit('close');
    }
  }
};